// extracted by mini-css-extract-plugin
module.exports = {"gvItems":"GVItems_gvItems__koY8Z","itemOuter":"GVItems_itemOuter__5Tc_T","item":"GVItems_item__BVZby"};